import { Message } from '@meitu/saas-ui';
import { getFramework } from '@/framework';
import { getLocaleStore } from '@/i18n';
import { type IRenderContextMenuItemArgs } from '@/plugins/context-menu';
import { LayerType } from '@/version-types';
import type { BackgroundLayer } from '../../index';

export const backgroundSplitItem = (
    { operateLayerType, isImageEditor }: IRenderContextMenuItemArgs,
    identity: string,
) => {
    const { $t } = getLocaleStore();
    const framework = getFramework(identity);

    if (isImageEditor) return null;
    if (operateLayerType !== LayerType.BACKGROUND_LAYER) return null;
    if (framework.service.edgelessCanvas.isEdgelessMode) return null;

    const item = {
        name: $t((v) => v.contextMenuLayer.menuConfig.backgroundSplit),
        type: 'backgroundSplit',
        icon: 'SeparateBackgroundBold',
        onClick: () => {
            const backgroundLayer = framework.service.registration.getInstance<BackgroundLayer>('BackgroundLayer');
            if (!backgroundLayer) {
                throw new Error('BackgroundLayer is not found');
            }
            backgroundLayer.convertBackgroundToImage();
            Message.success($t((v) => v.contextMenuLayer.menu.successText));
        },
    };

    return item;
};
